module.exports = __webpack_public_path__ + "img/product02-zhinengfengkong.a898459c.svg";